import React, { useContext, useEffect, useMemo, useState } from 'react';
import { TrelloPowerUpContext } from '@powerupsclub/trello';
import Select from '@atlaskit/select';
import { LoadingButton } from '@atlaskit/button';
import Spinner from '@atlaskit/spinner';

import styles from './SendToBoard.module.scss';

const SERVER_URL = process.env.REACT_APP_SERVER_URL || 'http://localhost:3001';

async function sendToBoard(
  idCard: string,
  idList: string,
  pos: number,
  jwt: string
) {
  const repsonse = await fetch(
    `${SERVER_URL}/archive-manager/send-card-to-board/${idCard}`,
    {
      method: 'post',
      body: JSON.stringify({
        pos,
        idList,
        jwt,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );

  return repsonse.json();
}

export const SendToBoard: React.FC = () => {
  const {
    trelloIframe,
    isLoading: trelloLoading,
    token,
  } = useContext(TrelloPowerUpContext);
  const [lists, setLists] = useState<any[]>([]);

  const [_loading, setLoading] = useState(true);
  const [idList, setIdList] = useState<string | undefined>();
  const [pos, setPos] = useState<any>({
    label: '1',
    value: 'top',
  });

  const loading = _loading || trelloLoading;

  useEffect(() => {
    async function load() {
      const _lists = await trelloIframe.lists('all');
      setLists(_lists);

      setLoading(false);
    }

    load();
  }, [trelloIframe]);

  const positionOptions = useMemo(() => {
    const list = lists.find((list) => list.id === idList);

    const cardCount = list?.cards.length;

    const positions = list?.cards.map((c: any) => c.pos);

    const options = [];

    for (let i = 0; i <= cardCount; i++) {
      options.push({
        label: `${i + 1}`,
        value: positions[i] ? positions[i] - 1 : 'bottom',
      });
    }

    return options;
  }, [lists, idList]);

  const listOptions = lists.map((list) => ({
    label: list.name,
    value: list.id,
  }));

  const onListSelect = (option: { value: string }) => {
    setIdList(option.value);
    setPos({
      label: '1',
      value: 'top',
    });
  };

  const onPosSelect = (option: any) => {
    setPos(option);
  };

  const handleSubmit = async () => {
    if (!idList) {
      return;
    }

    const idCard = trelloIframe.arg('idCard');

    const jwt = await trelloIframe.jwt({ state: JSON.stringify({ token }) });

    await sendToBoard(idCard, idList, pos.value, jwt);

    await trelloIframe.set(
      'board',
      'private',
      'lastLoadTime',
      new Date().getTime()
    );

    trelloIframe.closePopup();
    trelloIframe.alert({
      message: 'Card was sent back to the board',
    });
  };

  if (loading) {
    return (
      <div className={styles.loadingContainer}>
        <Spinner size="large" />
      </div>
    );
  }

  return (
    <div>
      <Select
        placeholder="Select a list..."
        className={styles.select}
        options={listOptions}
        minMenuHeight={200}
        maxMenuHeight={200}
        onMenuOpen={() => {
          trelloIframe.sizeTo(250);
        }}
        onMenuClose={() => {
          trelloIframe.sizeTo(148);
        }}
        onChange={onListSelect as any}
      />
      <Select
        placeholder="Select a position..."
        className={styles.select}
        isDisabled={positionOptions.length === 0}
        options={positionOptions}
        minMenuHeight={200}
        maxMenuHeight={200}
        onMenuOpen={() => {
          trelloIframe.sizeTo(298);
        }}
        onMenuClose={() => {
          trelloIframe.sizeTo(148);
        }}
        onChange={onPosSelect as any}
        value={pos}
      />
      <LoadingButton
        appearance="primary"
        shouldFitContainer
        onClick={handleSubmit}
        isDisabled={!idList}
      >
        Send to board
      </LoadingButton>
    </div>
  );
};
